import { FC, SVGProps } from 'react';

const MessageCheckIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  color = '#2d2d2d',
  size = 20,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        d="M9.97977 17.5253C12.1046 17.5326 14.2319 16.6406 15.7473 14.8428C18.0148 12.153 18.0861 8.11654 15.9086 5.35353C13.0739 1.75541 7.83788 1.53018 4.70166 4.677C2.40907 6.97654 1.91392 10.3835 3.19838 13.1702C3.30536 13.4377 3.71947 14.1728 3.99743 14.6565C4.15546 14.9314 4.13925 15.2705 3.95691 15.529C3.77376 15.7876 3.54199 16.1186 3.36128 16.3902C3.03793 16.8756 3.38153 17.5261 3.96339 17.5253L4.41288 17.5251C6.39096 17.5243 9.29018 17.523 9.97977 17.5253Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.27686 10.0497L9.06619 11.8451L12.6441 8.25427"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default MessageCheckIcon;
